<div style="width: 800px; height: 600px;" data-cy="appointments-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="appointments-header-section">
      <div class="section-header-title" data-cy="appointments-title-text">
        Patient Appointments
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow-y: hidden;" data-cy="appointments-content-section">
      <div style="height: 100%; width: 100%; overflow-y: auto;" data-cy="appointments-list-container">
        @for (appointment of appointments; track appointment) {
          <div [ngClass]="{'current-case-appointment': isCurrentCaseAppointment(appointment)}"
            style="display: flex; border: 2px solid var(--tdo-primary); border-radius: var(--border-radius); margin-bottom: 2px; padding: 4px;" data-cy="appointments-item-row">
            <div style="flex-basis: 120px;" data-cy="appointments-date-column">
              <div style="font-weight: 500;" data-cy="appointments-date-value">{{appointment.StartDate | date: 'shortDate'}}</div>
              <div data-cy="appointments-weekday-value">{{getWeekDay(appointment.StartDate)}}</div>
            </div>
            <div style="flex: 1;" data-cy="appointments-time-column">
              <div style="display: flex;">
                <div style='flex-basis: 40px; text-align: right; margin-right: 6px;' data-cy="appointments-from-label">From:</div>
                <div data-cy="appointments-start-time">{{appointment.StartDate | date: 'shortTime'}}</div>
              </div>
              <div style="display: flex;">
                <div style='flex-basis: 40px; text-align: right; margin-right: 6px;' data-cy="appointments-to-label">To:</div>
                <div data-cy="appointments-end-time">{{appointment.EndDate | date: 'shortTime'}}</div>
              </div>
            </div>
            <div style="flex: 1;" data-cy="appointments-type-column">
              <div style="display: flex;">
                <div style='flex-basis: 50px; text-align: right; margin-right: 6px;' data-cy="appointments-for-label">For:</div>
                @if (appointment.Procedure?.enumProcedureTypeID) {
                  <div data-cy="appointments-procedure-type">{{getProcedureType(appointment.Procedure.enumProcedureTypeID)}}</div>
                }
                @if (!appointment.Procedure?.enumProcedureTypeID) {
                  <div data-cy="appointments-procedure-none">-</div>
                }
              </div>
              <div style="display: flex;">
                <div style='flex-basis: 50px; text-align: right; margin-right: 6px;' data-cy="appointments-type-label">Type:</div>
                <div data-cy="appointments-type-value">{{getAppointmentType(appointment.enumApptTypeId)}}</div>
              </div>
              <div style="display: flex;">
                <div style='flex-basis: 50px; text-align: right; margin-right: 6px;' data-cy="appointments-status-label">Status:</div>
                <div data-cy="appointments-status-value">{{getAppointmentStatus(appointment.enumApptStatusId)}}</div>
              </div>
            </div>
            <div style="flex: 1;" data-cy="appointments-details-column">
              <div style="display: flex;">
                <div style='flex-basis: 40px; text-align: right; margin-right: 6px;' data-cy="appointments-subject-label">Subject:</div>
                <div data-cy="appointments-subject-value">{{appointment.Subject}}</div>
              </div>
              <div style="display: flex;">
                <div style='flex-basis: 40px; text-align: right; margin-right: 6px;' data-cy="appointments-provider-label">Provider:</div>
                <div data-cy="appointments-provider-value">{{getDoctor(appointment.Label_DoctorId)}}</div>
              </div>
              <div style="display: flex;">
                <div style='flex-basis: 40px; text-align: right; margin-right: 6px;' data-cy="appointments-note-label">Note:</div>
                <div data-cy="appointments-note-value">{{appointment.Description}}</div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px; min-height: 46px;" data-cy="appointments-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="appointments-ok-button">Ok</button>
    </div>
  </div>
</div>
